import { isRealNumber } from "./isNumber";

export const validateCriterion = (criterion) => {
  if (!criterion.oznaka.trim()) {
    return {
      success: false,
      title: "Nepotpun unos!",
      message: "Oznaka kriterijuma je obavezna.",
    };
  }
  if (!criterion.naziv.trim()) {
    return {
      success: false,
      title: "Nepotpun unos!",
      message: "Naziv kriterijuma je obavezan.",
    };
  }
  if (!criterion.tip) {
    return {
      success: false,
      title: "Nepotpun unos!",
      message: "Tip kriterijuma je obavezan.",
    };
  }
  if (
    !isRealNumber(criterion.koeficijent) ||
    criterion.koeficijent === "" ||
    criterion.koeficijent < 0 ||
    criterion.koeficijent > 1
  ) {
    return {
      success: false,
      title: "Neadekvatan unos!",
      message: "Koeficijent kriterijuma mora biti broj između 0 i 1.",
    };
  }
  if (criterion.status === "") {
    return {
      success: false,
      title: "Nepotpun unos!",
      message: "Status kriterijuma je obavezan.",
    };
  }
  return { success: true };
};

